<form-field [formGroup]="fieldConfig.formGroup"
            [attr.class]="fieldConfig.className"
            [options]="fieldConfig">
    <div [class.has-icon]="fieldConfig.icon" class="field">
        <i *ngIf="fieldConfig.icon" [attr.class]="fieldConfig.icon"></i>
        <p-rating
            [formControlName]="fieldConfig.formControlName"
            [stars]="numberOfStars"
            (onRate)="change.emit($event)"
            (onCancel)="cancel.emit($event)"></p-rating>
    </div>
</form-field>
